import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Banner from "../../../components/web/home/Banner";
import MediaCoverage from "../../../components/web/home/MediaCoverage";
import Stories from "../../../components/web/home/Stories";
import TrustedBy from "../../../components/web/home/TrustedBy";
import VideoBanner from "../../../components/web/home/VideoBanner";
import PublicLayout from "../../../layouts/PublicLayout";

export default function Home() {
  const { keycloak } = useKeycloak();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (keycloak.token && location.pathname === "/") {
      navigate("/admin/dashboard");
    }
  }, [keycloak.token, location.pathname, navigate]);
  return (
    <PublicLayout title="Home | Sheba Business Portal">
      <Banner />
      <VideoBanner />
      <TrustedBy />
      <Stories />
      <MediaCoverage />
    </PublicLayout>
  );
}
